import { Link } from 'react-router-dom';
import { BrandSquareMono } from '~/brand/BrandContext';

export function NavLogo() {
  return (
    <Link to='/' className='ml-4 mr-2 flex items-center pb-0 lg:hidden'>
      <BrandSquareMono className='h-9 w-9' />
    </Link>
  );
}
